import { useCallback } from 'react';

import { TAKE_BACK_BAG_COLLECTION_URL } from '../../config/externalURL';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../Button';
import TbbSvg from '../SvgComponents/Tbb_svg';

import styles from './BuyTbbButton.module.scss';

const { cta } = styles;

const BuyTbbButton = () => {
  const handleClick = useCallback(() => {
    window.location.href = TAKE_BACK_BAG_COLLECTION_URL;
  }, []);

  return (
    <Button
      className={cta}
      size={BUTTON_SIZE.SMALL}
      type={BUTTON_TYPE.QUATERNARY}
      onClick={handleClick}
    >
      <TbbSvg color="#fff" width={20} height={20} />
      <span>Buy TBB</span>
    </Button>
  );
};

export default BuyTbbButton;
